import { useCallback, useState } from 'react';
var useForceUpdate = function () {
    var _a = useState(), updateComponent = _a[1];
    return useCallback(function () { return updateComponent([]); }, []);
};
export default useForceUpdate;
